import React from "react";

type ToggleProps = {
  disabled: boolean;
  pressed: boolean;
  onToggle: React.MouseEventHandler<HTMLButtonElement> | undefined;
};

const Toggle = ({ disabled, pressed, onToggle }: ToggleProps) => (
  <button
    id="dimensionToggle"
    type="button"
    aria-pressed={pressed}
    disabled={disabled}
    onClick={onToggle}
    className={`cursor-pointer flex flex-row items-center top h-5 w-8 rounded-full m-0 p-0 border-none ${
      pressed
        ? "bg-green-500 shadow-[0_0_0_1px_inset_green]"
        : "bg-[#7A8671] shadow-[0_0_0_1px_inset_#7A8671]"
    }`}
    data-testid="showDimensionsToggle"
  >
    <div
      className={`absolute box-border z-10 h-5 w-5 border-[2px] border-solid rounded-full bg-white transition-all ${
        pressed ? "pressed ml-3 border-green-500" : "ml-0 border-[#7A8671]"
      }`}
    />
  </button>
);

export default Toggle;
